"use client";
import * as React from "react";
const SvgBuildSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7.95 1.36A4.7 4.7 0 0 0 2.62.47l3.1 3.1-2.14 2.15-3.12-3.1a4.6 4.6 0 0 0 .9 5.3A4.7 4.7 0 0 0 6.3 8.98L13.34 16 16 13.35l-7.01-7a4.6 4.6 0 0 0-1.04-5" }));
export {
  SvgBuildSharp as default
};
